import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

// Fonction pour formater la date au format DD/MM/YYYY
const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Retourner la chaîne originale si invalide
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Erreur de formatage de date:', error);
    return dateString; // Retourner la chaîne originale en cas d'erreur
  }
};

const UpdateCard = ({
  date,
  title,
  subtitle,
  description,
  linkText,
  linkHref,
  variant = "default", // 'default', 'warning', 'info'
  ...props
}) => {
  const theme = useTheme();
  // Couleurs selon le variant
  const getColors = () => {
    switch (variant) {
      case "warning":
        return {
          border: "#ff9800",
          background: "#fff3e0",
          accent: "#ff9800",
          dateColor: "#ff9800",
        };
      case "info":
        return {
          border: theme.palette.error.light,
          background: theme.palette.background.default,
          accent: theme.palette.error.main,
          dateColor: theme.palette.text.primary,
        };
      case "error":
        return {
          border: theme.palette.error.main,
          background: theme.palette.error.light,
          accent: theme.palette.error.main,
          dateColor: theme.palette.error.main,
        };
      default:
        return {
          border: "#FF6B35",
          background: "#FFF8F5",
          accent: "#FF6B35",
          dateColor: "#FF6B35",
        };
    }
  };

  const colors = getColors();

  return (
    <Box
      sx={{
        border: `1px solid ${colors.border}`,
        borderRadius: 2,
        backgroundColor: colors.background,
        mb: 3,
        overflow: "hidden",
        ...props.sx,
      }}
      {...props}
    >
      {/* Barre colorée à gauche */}
      <Box sx={{ display: "flex", gap: 1 }}>
        <Box
          sx={{
            width: 12,
            backgroundColor: colors.border,
            flexShrink: 0,
          }}
        />

        {/* Contenu */}
        <Box
          sx={{
            p: 3,
            flex: 1,
            backgroundColor: colors.background,
            // border: `1px solid ${colors.border}`,
          }}
        >
          {/* Date */}
          <Typography
            variant="caption"
            sx={{
              color: colors.dateColor,
              fontWeight: 600,
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: 0.5,
              mb: 1,
              display: "block",
            }}
          >
           {title} | {formatDate(date)}
          </Typography>

          {/* Titre */}
          <Typography
            variant="h3"
            sx={{
              fontWeight: 600,
              color: theme.palette.text.primary,
              mb: 2,
              fontSize: { xs: "1rem", md: "1.1rem" },
              lineHeight: 1.3,
            }}
          >
            {subtitle}
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              lineHeight: 1.6,
              mb: linkText ? 2 : 0,
              fontSize: { xs: "0.875rem", md: "0.9rem" },
            }}
          >
            {description}
          </Typography>

          {/* Lien */}
          {linkText && (
            <Typography
              component="a"
              href={linkHref}
              sx={{
                color: theme.palette.info.main,
                textDecoration: "underline",
                fontSize: "0.875rem",
                fontWeight: 500,
                "&:hover": {
                  color: theme.palette.info.main,
                  textDecoration: "none",
                },
              }}
            >
              {linkText}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateCard;
